import React from "react";
import Pagination from "./Pagination";
import PaginationMobile from "./PaginationMobile";
import { 
  ResponsivePaginationContainer,
  DesktopTabletPaginationWrapper,
  MobilePaginationWrapper2
} from "../../styles/dashboard";

type ResponsivePaginationProps = {
  onPageChange: (page: number) => void;
  totalPageCount: number;
  siblingCount?: number;
  currentPage: number;
  pageSize?: number;
  className?: string;
};

const ResponsivePagination: React.FC<ResponsivePaginationProps> = ({
  onPageChange,
  totalPageCount,
  siblingCount = 1,
  currentPage,
  className,
  pageSize
}) => {
  return (
    <ResponsivePaginationContainer className={className}>
      <DesktopTabletPaginationWrapper>
        <Pagination
          onPageChange={onPageChange}
          totalPageCount={totalPageCount}
          siblingCount={siblingCount}
          currentPage={currentPage}
          pageSize={pageSize}
        />
      </DesktopTabletPaginationWrapper>
      
      <MobilePaginationWrapper2>
        <PaginationMobile
          onPageChange={onPageChange}
          totalPageCount={totalPageCount}
          currentPage={currentPage}
          pageSize={pageSize}
        />
      </MobilePaginationWrapper2>
    </ResponsivePaginationContainer>
  );
};

export default ResponsivePagination;
